module.exports = __webpack_public_path__ + "static/media/farma_logo.01e61390.svg";